import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ENTERPRISE_MAX_DESCRIPTION, ENTERPRISE_PRO_DESCRIPTION, MAX_DESCRIPTION, PRO_DESCRIPTION, PRO_STUDENT_DESCRIPTION, PRO_STUDENT_UNVERIFIED_DESCRIPTION, STANDARD_DESCRIPTION, } from '#pplx/frontend/apps/ask/subscription/components/tierContent.js';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
export const PRO_PRICE_USD = {
    monthly: 20,
    yearly: 200,
    yearlyPerMonth: 17,
};
export const STUDENT_PRO_PRICE_USD = {
    monthly: 10,
    yearly: 100,
    yearlyPerMonth: 9,
};
export const getFormattedStudentPrices = () => {
    return {
        monthlyPrice: (_jsx(FormattedNumber, { value: STUDENT_PRO_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: STUDENT_PRO_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
    };
};
export const MAX_PRICE_USD = {
    monthly: 200,
    yearly: 2000,
    yearlyPerMonth: 167,
};
export const ENTERPRISE_PRO_PRICE_USD = {
    monthly: 40,
    yearly: 400,
    yearlyPerMonth: 34,
};
export const ENTERPRISE_MAX_PRICE_USD = {
    monthly: 325,
    yearly: 3250,
    yearlyPerMonth: 271,
};
// TODO(ENT-5920): per-seat price TBD.
export const ENTERPRISE_BASIC_PRICE_USD = {
    monthly: 0,
    yearly: 0,
    yearlyPerMonth: 0,
};
export const TierCardDescriptionsMap = {
    standard: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Free", id: "7d9e3a478f", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: 0, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: 0, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        buttonText: (_jsx(FormattedMessage, { defaultMessage: "Continue with free", id: "d37ca65ee6", description: "Text in the tier Metadata subscription section" })),
        description: STANDARD_DESCRIPTION,
    },
    pro: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Pro", id: "664687fdab", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: PRO_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: PRO_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        buttonText: (_jsx(FormattedMessage, { defaultMessage: "Continue with Pro", id: "efe33d4129", description: "Text in the tier Metadata subscription section" })),
        description: PRO_DESCRIPTION,
    },
    max: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Max", id: "ac6e6625fe", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: MAX_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: MAX_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        buttonText: (_jsx(FormattedMessage, { defaultMessage: "Continue with Max", id: "12e0f51677", description: "Text in the tier Metadata subscription section" })),
        description: MAX_DESCRIPTION,
    },
    enterprise_pro: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Enterprise Pro", id: "0d29f4ce70", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: ENTERPRISE_PRO_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: ENTERPRISE_PRO_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        buttonText: (_jsx(FormattedMessage, { defaultMessage: "Continue with Enterprise Pro", id: "b62f110f31", description: "Text in the tier Metadata subscription section" })),
        description: ENTERPRISE_PRO_DESCRIPTION,
    },
    enterprise_max: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Enterprise Max", id: "a472d697b6", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: ENTERPRISE_MAX_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: ENTERPRISE_MAX_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        buttonText: (_jsx(FormattedMessage, { defaultMessage: "Continue with Enterprise Max", id: "7f3fc9c39b", description: "Text in the tier Metadata subscription section" })),
        description: ENTERPRISE_MAX_DESCRIPTION,
    },
    pro_student: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Education Pro", id: "2daeefd3a2", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: STUDENT_PRO_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: STUDENT_PRO_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        description: PRO_STUDENT_DESCRIPTION,
    },
    pro_unverified_student: {
        title: (_jsx(FormattedMessage, { defaultMessage: "Education Pro", id: "2daeefd3a2", description: "Label in the tier Metadata subscription section" })),
        monthlyPrice: (_jsx(FormattedNumber, { value: STUDENT_PRO_PRICE_USD.monthly, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        yearlyPricePerMonth: (_jsx(FormattedNumber, { value: STUDENT_PRO_PRICE_USD.yearlyPerMonth, style: "currency", trailingZeroDisplay: "stripIfInteger", currency: "USD" })),
        buttonText: (_jsx(FormattedMessage, { defaultMessage: "Verify as student", id: "10b1cf52da", description: "Text in the tier Metadata subscription section" })),
        subButtonText: (_jsx(FormattedMessage, { defaultMessage: "Verify as educator", id: "fce03feacb", description: "Text in the tier Metadata subscription section" })),
        description: PRO_STUDENT_UNVERIFIED_DESCRIPTION,
    },
};
export const wrapInFragment = (content) => _jsx(_Fragment, { children: content });
export const getStudentDiscountDescription = () => (_jsx(FormattedMessage, { defaultMessage: "Unlock the full capabilities of Perplexity at a discount when using a valid educational email.", id: "3c8227dacc", description: "Inline text in the tier Metadata subscription section" }));
export const getFirstMonthFreeMonthlyMessage = () => (_jsx(FormattedMessage, { defaultMessage: "First month free, then {price, number, ::currency/USD .00/w}/month", id: "105bb74ac6", description: "Pro first-month-free promotion on monthly billing; price is the monthly price in US dollars charged after the free month", values: { price: 20 } }));
export const getFirstMonthFreeYearlyMessage = () => (_jsx(FormattedMessage, { defaultMessage: "First month free, then {price, number, ::currency/USD .00/w}/month", id: "77b7ad8632", description: "Pro first-month-free promotion on annual billing; price is the per-month equivalent in US dollars charged after the free month", values: { price: 17 } }));
export const getContactAdminMessage = () => (_jsx(FormattedMessage, { defaultMessage: "Contact your admin", id: "cd3f16a649", description: "Text in the tier Metadata subscription section" }));
//# sourceMappingURL=tierMetadata.js.map